import React, { useState } from 'react';
import EventDocumentBody from './eventDocumentBody.component';
import { FileTxtIcon, UUID } from '@umanforge/common';
import { EventDocument } from 'interfaces/document.interface';
import Button from '@common_components/buttons/button.component';
import { CrossIcon } from '@common_components/icons/cross.icon';
import DocViewer, { TXTRenderer } from '@cyntler/react-doc-viewer';
import { LoadingDocViewer } from './loadingDocViewer.component';
import { noDataDocViewer } from './noDataDocViewer.component';


interface EventDocumentTextProps {
  file: EventDocument;
  canDelete: boolean;
  isDeleted: boolean;
  isViewMode?: boolean;
  deleteFile: ( fileId: UUID ) => void;
}

const EventDocumentText: React.FC<EventDocumentTextProps> = ( { file, isDeleted, canDelete, isViewMode, deleteFile } ) => {

  const [ isOpen, setIsOpen ] = useState( false );


  const openPopup = () => {
    setIsOpen( true );
  };

  const closePopup = () => {
    setIsOpen( false );
  };

  return (
    <>
      <EventDocumentBody
        file={ file }
        isViewMode={ isViewMode }
        canDelete={ canDelete }
        isDeleted={ isDeleted }
        onClickFile={ openPopup }
        deleteFile={ deleteFile }
      >
        <FileTxtIcon
          className={`
            w-full h-full
            flex 
            px-4 py-0.5
            sm:px-5 sm:py-1
            md:px-6 md:py-2
            justify-center 
          `}
        />
      </EventDocumentBody>
      {
        isOpen &&
        <div className="fixed inset-0 flex items-center justify-center z-[100]">
          <div className="absolute inset-0 appear bg-gray-800 rounded-t-[11px] rounded-b-[6px]" />
          <div className='absolute flex h-fit w-full items-center justify-center'>
            <div className='flex flex-col h-fit w-full max-h-[80vh] rounded-md bg-white-base p-2'>
              <div className='flex w-full justify-end'>
                <Button
                  icon={
                    <CrossIcon className="group-hover:rotate-[360deg] transition-transform duration-700" size={7} />
                  }
                  color="bg-transparent"
                  colorHover="hover:bg-red-200"
                  textColorHover="hover:text-red-base"
                  hoverBorderColor="hover:border-transparent"
                  textSize="text-xl"
                  shadow="shadow-none"
                  onClick={ closePopup }
                />
              </div>
              <DocViewer
                className='overflow-auto'
                documents={ [ { uri: file.url, fileName: file.originalName } ] }
                pluginRenderers={ [ TXTRenderer ] }
                config={{
                  loadingRenderer: { overrideComponent: LoadingDocViewer },
                  noRenderer: { overrideComponent: noDataDocViewer }
                }}
              />
            </div>
          </div>
        </div>
      }
    </>
  );
};

export default EventDocumentText;
